
const downloadFile = ({ source, filename }) => {
  const link = document.createElement('a')
  link.href = source
  link.target = '_blank'
  if (filename) link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

export { downloadFile}